'use client';

import { useVisible } from '@/hooks';
import { Content, GroupField } from '@prismicio/client';
import { memo, useEffect, useState } from 'react';
import { Simplify } from '../../../../../../prismicio-types';
import Product from './Product';
import styles from './getOfferProducts.module.scss';

interface GetOfferProductsProps {
  products: GroupField<
    Simplify<Content.GetOfferSliceWithProductsPrimaryProductsItem>
  >;
  variation: 'withProducts' | 'onlyProducts' | 'productsWithButton';
}

const animationPaths = [
  '/static/animations/getOfferProducts/personal.json',
  '/static/animations/getOfferProducts/consolidation.json',
  '/static/animations/getOfferProducts/heloc.json',
];

const fetchAnimation = async (path: string) => {
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error(`Failed to fetch animation: ${path}`);
  }
  return response.json();
};

const GetOfferProductsComponent = ({
  products,
  variation,
}: GetOfferProductsProps) => {
  const [videoList, setVideoList] = useState<object[]>([]);
  const [isVisible, id] = useVisible();

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const fetchedVideos = await Promise.all(
          animationPaths.map((path) => fetchAnimation(path))
        );
        setVideoList(fetchedVideos);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching animations:', error);
      }
    };

    fetchVideos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animationPaths]);

  return (
    <article className={`${styles.products} ${styles[variation]}`} id={id}>
      {products.map((item, index) => (
        <Product
          key={index}
          item={item}
          index={index}
          isVisible={isVisible}
          animation={videoList[index]}
          variation={variation}
        />
      ))}
    </article>
  );
};

export const GetOfferProducts = memo(GetOfferProductsComponent);
